// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"76be4286","837":"e29c60fc"}[chunkId] + ".chunk.css";
};